import { render, staticRenderFns } from "./modalexample.vue?vue&type=template&id=be048b68&scoped=true&"
import script from "./modalexample.vue?vue&type=script&lang=js&"
export * from "./modalexample.vue?vue&type=script&lang=js&"
import style0 from "./modalexample.vue?vue&type=style&index=0&id=be048b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be048b68",
  null
  
)

export default component.exports